module.exports = __webpack_public_path__ + "img/fastcharger-request-semipublic.df54444e.svg";